import * as angular from 'angular';

import { ComponentDefinition, AccessRights } from '../../../../models';

// Seems not to be used anymore
class RightsTableController implements angular.IComponentController {
    isLoading: boolean;
    loadingMessage: string;
    rights: AccessRights;
    static $inject = [];
}

export const wtRightsTable: ComponentDefinition = {
    componentId: 'wtRightsTable',
    controller: RightsTableController,
    template: require('./rightsTable.component.html'),
    controllerAs: 'vm',
    bindings: {
        rights: '<',
        isEditMode: '<?',
        users: '<',
        roles: '<',
        formController: '=?'
    }
};
